import { ChevronDown } from "lucide-react";

export const FAQS: { q: string; a: string }[] = [
  {
    q: "Do my clients need to create an account?",
    a: "No. You send them a review link (on WhatsApp or email). They enter their name and email once and can start clicking and commenting immediately.",
  },
  {
    q: "Does it work with WordPress, Shopify and React/Next.js sites?",
    a: "Yes. The review link works with most public websites without installing anything. For login-protected pages or sites with strict security headers, paste our lightweight script tag — there are copy-paste instructions for WordPress, Shopify and Next.js.",
  },
  {
    q: "Will the script slow down my client's website?",
    a: "No. The widget is about 12 KB gzipped, loads asynchronously, lives inside a Shadow DOM so it can't break your CSS, and the site keeps working even if MarkFeed is down.",
  },
  {
    q: "Can clients leave feedback from their phone?",
    a: "Absolutely. Most Indian clients review on mobile. They tap an element, type the comment and submit — we capture the device, screen size and a screenshot automatically.",
  },
  {
    q: "How do you charge? Is GST included?",
    a: "Plans are billed in ₹ INR via Razorpay — UPI, cards, net banking and wallets. Nothing renews automatically: you pay for each month yourself, and every payment comes with an invoice. Where GST applies, it's added at checkout and shown before you pay.",
  },
  {
    q: "Can I send review links on WhatsApp?",
    a: "Yes. Every review link has a one-tap WhatsApp share with a ready-made message, and you can customise the template with your agency name. Automated WhatsApp notifications work with Meta Cloud API, Interakt and other providers.",
  },
  {
    q: "Is our data safe?",
    a: "Each organisation's projects, feedback and files are isolated and checked on the server for every request. Review links are unguessable, can expire and can be revoked anytime.",
  },
];

export function Faq() {
  return (
    <div className="divide-y divide-line rounded-2xl border border-line bg-white">
      {FAQS.map((f) => (
        <details key={f.q} className="group px-6 py-5 [&_summary::-webkit-details-marker]:hidden">
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-[15px] font-medium text-ink">
            {f.q}
            <ChevronDown className="size-4 shrink-0 text-slate-400 transition-transform group-open:rotate-180" />
          </summary>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{f.a}</p>
        </details>
      ))}
    </div>
  );
}
